import * as React from 'react';
import { FC } from 'react';

import { BlankScreen } from 'components/blank-screen';
import { EmptyState } from 'components/features/components/empty-state';
import LoadingAnimation from 'components/loading-animation';

import { SpinnerContainer } from './loyalty-not-enrolled.styled';
import { useFeaturesLoyaltyNotEnrolled } from './use-features-loyalty-not-enrolled';

const LoyaltyNotEnrolled: FC<React.PropsWithChildren<unknown>> = () => {
  const { data, loading, refetch } = useFeaturesLoyaltyNotEnrolled();

  if (loading) {
    return (
      <SpinnerContainer>
        <LoadingAnimation />
      </SpinnerContainer>
    );
  }
  if (!data) {
    return (
      <BlankScreen
        context={{
          reason: 'LoyaltyNotEnrolled no data after loading',
        }}
        onReload={refetch}
      />
    );
  }
  return <EmptyState content={data} />;
};

export default LoyaltyNotEnrolled;
